import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import './index.css';
import './App.css';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { queryClient } from '@/config/queryClient';
import { router } from '@/router';
import LoadingSpinner from '@/components/LoadingSpinner';

const QueryDevtools = import.meta.env.DEV
  ? lazy(() => import('@/components/QueryDevtools').then((module) => ({ default: module.QueryDevtools })))
  : null;

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

function InnerApp() {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <LoadingSpinner text="Carregando..." />
      </div>
    );
  }

  return (
    <RouterProvider
      router={router}
      context={{ auth }}
    />
  );
}

createRoot(container).render(
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <InnerApp />
      {QueryDevtools ? (
        <Suspense fallback={null}>
          <QueryDevtools />
        </Suspense>
      ) : null}
    </QueryClientProvider>
  </AuthProvider>,
);
